import productImg from "@/assets/product-img.png";

/**
 * Branded loader shown for a few seconds right after a successful login
 * (see AuthContext's `justLoggedIn`) — the static product shot before the
 * dashboard appears.
 */
export default function PostLoginLoader() {
  return (
    <div className="fixed inset-0 z-[2000] bg-kl-black flex flex-col items-center justify-center kl-grain" data-testid="post-login-loader">
      <img src={productImg} alt="KyraLink" className="w-36 drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)]" />
      <p className="kl-label-dark mt-8">Establishing link…</p>
    </div>
  );
}
